<div class="page">
    <app-step-progress [steps]="steps"></app-step-progress>
    <app-page-title [title]="'Photo Upload'"></app-page-title>
    <app-selected-test-info></app-selected-test-info>
    <div class="row">
        <div class="col-md-12">
            <p> In order for us to administer your test online and process your score report, we will require a captured photo of you through your device. Please click the "Take Photo" button when you are ready.</p>
            <br />
            <div>
                <a
                    class="btn btn-primary mr-2"
                    (click)="openModal(true)"
                >
                    <span>
                        <i
                            class="fa fa-camera-retro"
                            aria-hidden="true"
                        ></i>
                    </span> Photo Capture
                </a>
                <a
                    class="btn btn-primary"
                    (click)="openModal(false)"
                >
                    <span>
                        <i
                            class="fa fa-upload"
                            aria-hidden="true"
                        ></i>
                    </span> Photo Upload
                </a>
            </div>
        </div>
        <ng-template
            #content
            let-modal
        >
            <div class="modal-header">
                <h4 class="modal-title"> {{ showPhotoCapture ? "Photo Capture" : "Photo  Upload" }} </h4>
            </div>
            <div class="modal-body">
                <div *ngIf="!showPhotoCapture">
                    <app-document-upload-form
                        [regBlobDataTypeId]=RegBlobDataTypeEnum.PictureFromRegistration
                        (updateUploadStatus)="changeStatus()"
                    ></app-document-upload-form>
                </div>
                <div *ngIf="showPhotoCapture">
                    <app-photo-capture (updateStatus)="changeStatus()"></app-photo-capture>
                </div>
            </div>
            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-primary"
                    (click)="modal.dismiss('Cross click')"
                >
                    Close
                </button>
            </div>
        </ng-template>
        <div>
            <button
                type="button"
                [disabled]="!photoUploaded"
                class="btn btn-primary m-3"
                (click)=redirectNextStep()
            >Continue Registration</button>
        </div>
    </div>
</div>
